import { createFileRoute } from '@tanstack/react-router'
import { InvoiceList } from '@/views/invoices/index'

export const Route = createFileRoute('/_authenticated/invoices/')({
  component: InvoiceList,
})
